import { render } from "./OfficePanels.vue?vue&type=template&id=2d034e77"
import script from "./OfficePanels.vue?vue&type=script&lang=js"
export * from "./OfficePanels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__